export const HttpCodes = {
    OK: 200,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
    CREATED: 201,
};

export const DEFAULT_CURRENCY = {
    forceRound: false,
    forceRoundFromAmount: 1000,
    name: 'USD',
    rate: 1,
    // eslint-disable-next-line no-template-curly-in-string
    template: '${{amount}}',
    symbol: '',
};
